import { HttpErrorResponse } from "@angular/common/http";
import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import notify from "devextreme/ui/notify";
import { FileTransfersService, IOcbFileTransfer } from "../../core";
import { FileTransferFormComponent } from "../../shared";

@Component({
    selector: 'app-file-transfer',
    templateUrl: './file-transfer.component.html',
    styleUrls: ['./file-transfer.component.scss'],
})
export class FileTransferComponent implements AfterViewInit {
    @ViewChild("fileTransferTab") fileTransferTab?: FileTransferFormComponent;

    protected currentEnvironmentId: string = '';
    protected fileTransfer: IOcbFileTransfer = {} as IOcbFileTransfer;

    constructor(private route: ActivatedRoute,
        private router: Router,
        private fileTransfersService: FileTransfersService) {}


    ngAfterViewInit() {
        if (!this.fileTransferTab) return;

        this.fileTransferTab.showProgressBar = true;
        this.route.params.subscribe(_ => {
            this.currentEnvironmentId = this.route.snapshot.params.id;
            this.fileTransferTab.environmentId = this.route.snapshot.params.id;
            if (this.route.snapshot.params.ft === 'new') {
                this.fileTransferTab.showProgressBar = false;
                this.fileTransferTab.newFileTransfer = true;
                this.fileTransferTab.loadData();
                return;
            }
            this.fileTransfersService.getFileTransfer(this.route.snapshot.params.ft).subscribe({
                next: (fileTransfer) => {
                    this.fileTransferTab.showProgressBar = false;
                    this.fileTransfer = fileTransfer;
                    this.fileTransferTab.loadData();
                },
                error: (error) => {
                    this.fileTransferTab.showProgressBar = false;
                    this.handleError(error);
                }
            });
        });
    }

    private handleError(error: any): void {
        let message: '';
        if (error instanceof HttpErrorResponse) {
            if (error.error.hasOwnProperty('message')) {
                message = error.error.message;
            } else if (error.error.hasOwnProperty('name')) {
                message = error.error.name;
            } else {
                message = error.error;
            }
        } else {
            message = error;
        }

        notify(message, 'error', 3000);
    }
    
}